module.exports = __webpack_public_path__ + "static/img/8 2020.12 研究生工作站.167ee47d.jpg";